import { OPTIONS_INTEGRATION, ORIGIN } from 'app-constants'
import { http } from 'hooks'

export function tokenService() {
  function generateToken(document, source, tokenType) {
    return http.post(
      '/app/v1/token-validation/generate',
      { document, source, tokenType, brand: ORIGIN },
      OPTIONS_INTEGRATION
    )
  }

  function confirmToken(document, token) {
    return http.post(
      '/app/v1/token-validation/confirm',
      { document, token },
      { ...OPTIONS_INTEGRATION, headers: { ...OPTIONS_INTEGRATION.headers, 'x-brand': ORIGIN } }
    )
  }

  return {
    generateToken,
    confirmToken,
  }
}
